import React from 'react'

export const Slot = ({ location }) => {
    return <div id={ `slot-${ location }` }></div>
}


export default Slot;